module.exports = __webpack_public_path__ + "img/logo_victoria.d6a5d739.png";